import React, { act, useEffect, useState } from "react";
import CustomDialog from "../../components/common/CustomDialog";
import { CiSettings } from "react-icons/ci";
import * as Yup from "yup";
import {
  assignRMToLead,
  getAllCompaniesUrl,
  getRegionsList,
  getRMList,
} from "../../utils/urls";
import axios from "axios";
import { errorToast, successToast } from "../../utils/toasts";
import { Form, Formik } from "formik";
import CustomSelect from "../../components/common/CustomSelect";
import CustomTextInput from "../../components/common/CustomTextInput";
import CustomButton from "../../components/common/CustomButton/CustomButton";
import { hideLoader, showLoader } from "../../utils/loader";

function AssignRelationshipManagerToLead({ leadDetails, actionType, onClose }) {
  const [companyList, setCompanyList] = useState([]);
  const [regionList, setRegionList] = useState([]);
  const [relationshipsManager, setRelationshipsManager] = useState([]);

  useEffect(() => {
    console.log({ leadDetails, actionType });

    if (actionType === "Assign TO Company Manager") {
      if (leadDetails?.product_id) {
        getRegionsFromServerByCompanyId();
      } else {
        getCompanyFromServer();
      }
    } else if (actionType === "Assign TO Admin Manager") {
      getRelationshipManagersByRegionIdFromServer(null);
    }
  }, []);

  async function getCompanyFromServer() {
    showLoader("Fetching data...");
    axios
      .get(`${getAllCompaniesUrl}?is_all=true&is_publish=true`)
      .then((res) => {
        setCompanyList(res?.data?.data || []);
      })
      .catch((err) => {
        console.log(err?.response);
        errorToast("Error fetching companies!");
      }).finally(() => {
        hideLoader();
      });
  }
  async function getRegionsFromServerByCompanyId(selected_company_id) {
    showLoader("Fetching data...");
    axios
      .get(
        `${getRegionsList}/${
          selected_company_id
            ? selected_company_id
            : leadDetails?.product_id?.company_id?.company_id
        }`
      )
      .then((res) => {
        setRegionList(res?.data?.data || []);
      })
      .catch((err) => {
        console.log(err?.response);
        errorToast("Error fetching regions!");
      }).finally(() => {
        hideLoader();
      });;
  }

  async function getRelationshipManagersByRegionIdFromServer(_region_id) {
    showLoader("Fetching data...");
    axios
      .get(
        `${getRMList}/${
          leadDetails?.product_id?.company_id?.company_id || "null"
        }?region_id=${_region_id}&is_admin_rm=${_region_id ? false : true}`
      )
      .then((res) => {
        setRelationshipsManager(res?.data?.data || []);
      })
      .catch((err) => {
        console.log(err?.response);
        errorToast("Error fetching relationship managers!");
      }).finally(() => {
        hideLoader();
      });;
  }

  async function assignRmToLead(relationship_manager_id, setSubmitting) {
    const postBody = {
      lead_product_relation_id: leadDetails?.lead_product_id,
      relationship_manager_id: relationship_manager_id,
    };
    axios
      .post(`${assignRMToLead}`, postBody)
      .then((res) => {
        successToast("Relationship manager assigned.");
        onClose(true);
      })
      .catch((err) => {
        console.log(err?.response);
        errorToast(err?.response?.error?.message || "Error assigning RM!");
      }).finally(() => {
        setSubmitting(false);
      });
  }

  return (
    <CustomDialog
      open={true}
      setOpen={() => {}}
      noTitleWrapper={true}
      className="mt-0"
      width={"70vw"}
      dontCloseOnOverlay={true}
      // height={"80vh"}
    >
      <div className="flex flex-col justify-between">
        <div className="flex w-full gap-2 items-center mb-4">
          <CiSettings />
          <p className="text-black font-semibold">
            Assign Relationship Manager
          </p>
        </div>

        {/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~  */}

        <Formik
          initialValues={{
            region_id: "",
            relationship_manager_id: "",
            contact_number: "",
          }}
          validationSchema={
            actionType === "Assign TO Company Manager"
              ? validationSchemaForCompanyRm(
                  actionType === "Assign TO Company Manager" &&
                    !leadDetails?.product_id
                )
              : validationSchemaForAdminRm
          }
          onSubmit={(values, { setSubmitting }) => {
            console.log(values);
            assignRmToLead(values.relationship_manager_id, setSubmitting);
            // {
            //     "region_id": "4206d08b-799c-4f3f-b50a-16c545d6dc47",
            //     "relationship_manager_id": "be5fe278-2fe6-418b-9ce1-b099b16855e2",
            //     "contact_number": "1234567890"
            // }
          }}
        >
          {({
            values,
            setFieldValue,
            errors,
            touched,
            validateField,
            isValid,
            setTouched,
            isSubmitting
          }) => {
            // console.log("values", values, isValid, errors, touched);

            return (
              <>
                <div className="pt-4 flex-1 border-t border-[#E2EBF3]">
                  {/* <p className="text-[1.rem] font-[600] text-[#2C2C2C] mb-4">
                        Enter Lead Details{" "}
                    </p> */}
                  <Form className="space-y-4">
                    <div className=" h-[calc(100vh_-_24rem)] overflow-y-auto">
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {actionType === "Assign TO Company Manager" &&
                          !leadDetails?.product_id && (
                            <CustomSelect
                              label="Company"
                              name="company_id"
                              required
                              placeholder={"Select Company"}
                              menuList={companyList?.map((_comp) => ({
                                label: _comp?.company_name,
                                value: _comp?.company_id,
                              }))}
                              onChange={(e) => {
                                const selectedCompanyId = e.target.value;
                                console.log(
                                  "selectedCompanyId",
                                  selectedCompanyId
                                );
                                getRegionsFromServerByCompanyId(
                                  selectedCompanyId
                                );
                              }}
                            />
                          )}
                        {actionType === "Assign TO Company Manager" && (
                          <CustomSelect
                            label="Region"
                            name="region_id"
                            required
                            placeholder={"Select Region"}
                            menuList={regionList?.map((_comp) => ({
                              label: _comp?.title,
                              value: _comp?.region_id,
                            }))}
                            onChange={(e) => {
                              const selectedRegionId = e.target.value;
                              console.log("selectedRegionId", selectedRegionId);
                              getRelationshipManagersByRegionIdFromServer(
                                selectedRegionId
                              );
                            }}
                          />
                        )}
                        <CustomSelect
                          label="Relationship Manager"
                          name="relationship_manager_id"
                          required
                          placeholder={"Select Relationship Manager"}
                          //   disabled={
                          //     relationshipsManager?.length === 0 ||
                          //     !values.region_id
                          //   }
                          menuList={relationshipsManager?.map((_comp) => ({
                            label: _comp?.name,
                            value: _comp?.rm_id,
                          }))}
                          onChange={(e) => {
                            const selectedRMId = e.target.value;
                            const selectedRM = relationshipsManager?.find(
                              (_rm) => _rm?.rm_id === selectedRMId
                            );
                            if (selectedRM?.contact_number) {
                              setFieldValue(
                                "contact_number",
                                selectedRM?.contact_number
                              );
                            }
                          }}
                        />
                        <CustomTextInput
                          name="contact_number"
                          label="Contact Number"
                          disabled={true}
                          placeholder="Contact Number"
                          required
                        />
                      </div>
                    </div>
                    <div className="flex justify-between gap-4">
                      {/* <button type="submit" className="btn-primary" disabled={!isEmailVerified || !isMobileVerified}>
                                Save & Next
                            </button> */}
                      <CustomButton
                        type="button"
                        variant="outlined"
                        label="Close"
                        onClick={() => onClose?.(false)}
                      />
                      <CustomButton
                        type="submit"
                        label="Assign"
                        isLoading={isSubmitting}
                        disabled={!isValid}
                      />
                    </div>
                  </Form>
                </div>
              </>
            );
          }}
        </Formik>

        {/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~  */}
      </div>
    </CustomDialog>
  );
}

export default AssignRelationshipManagerToLead;

const validationSchemaForCompanyRm = (is_company) => {
  if (is_company) {
    return Yup.object({
      company_id: Yup.string().required("Required"),
      region_id: Yup.string().required("Required"),
      relationship_manager_id: Yup.string().required("Required"),
      contact_number: Yup.string().optional(),
    });
  } else {
    return Yup.object({
      region_id: Yup.string().required("Required"),
      relationship_manager_id: Yup.string().required("Required"),
      contact_number: Yup.string().optional(),
    });
  }
};

const validationSchemaForAdminRm = Yup.object({
  relationship_manager_id: Yup.string().required("Required"),
  contact_number: Yup.string().optional(),
});
